import React from 'react';

import * as S from './Cases.style';
import * as T from './Cases.types';

export const Cases: React.FC<T.CasesDirectCollection> = ({ items }) => {
  return (
    <S.Casesdesucesso className="section">
      <S.Container>
        <h3>Conheça os cases de sucesso do Direct</h3>
        <div className="content">
          {items.map((item) => {
            return (
              <div key={item.title} className="item">
                <a href={item.url} target="_blank" rel="noreferrer">
                  <img src={item.logo.url} alt={item.title} width={250} height={100} />
                </a>
              </div>
            );
          })}
        </div>
      </S.Container>
    </S.Casesdesucesso>
  );
};
